import QuestionnaireApi from '../api/questionnaire';
import Questionnaire from '../models/questionnaire/questionnaire';
import QuestionnaireAnswer from '../models/questionnaire/answer';

const env = process.env;
const questionnaireApi = new QuestionnaireApi(
  env.VUE_APP_API_QUESTIONNAIRE_URL,
  parseInt(env.VUE_APP_API_QUESTIONNAIRE_TIMEOUT)
);

const state = {
  questionnaires: [],
  answers: {},
};

const getters = {
  questionnaireClientAnswers: state => clientId => {
    if (!state.answers[clientId]) {
      return [];
    }

    return state.answers[clientId];
  },
};

const mutations = {
  QUESTIONNAIRES_SET_QUESTIONNAIRES: (state, payload) => {
    const questionnaires = [];

    for (const item of payload) {
      questionnaires.push(new Questionnaire(item));
    }

    state.questionnaires = questionnaires;
  },

  QUESTIONNAIRE_SET_ANSWERS: (state, payload) => {
    const answers = [];

    for (const item of payload.result) {
      answers.push(new QuestionnaireAnswer(item));
    }

    state.answers[payload.clientId] = answers;
    state.answers = Object.assign({}, state.answers);
  },
};

const actions = {
  QUESTIONNAIRE_LOAD_QUESTIONNAIRES: async (context) => {
    const token = context.rootState.token;
    const data = await questionnaireApi.getQuestionnaires(token);

    context.commit('QUESTIONNAIRES_SET_QUESTIONNAIRES', data);
  },

  QUESTIONNAIRE_LOAD_ANSWERS: async (context, payload) => {
    const token = context.rootState.token;
    const result = await questionnaireApi.getUserAnswers(token, payload);

    context.commit('QUESTIONNAIRE_SET_ANSWERS', { clientId: payload, result });
  },

  QUESTIONNAIRE_ADD_COMMENT: async (context, payload) => {
    const token = context.rootState.token;
    const { id, comment, client } = payload;

    await questionnaireApi.addAnswerComment(token, id, comment);

    await context.dispatch('QUESTIONNAIRE_LOAD_ANSWERS', client);
  },

  QUESTIONNAIRE_UPDATE_ANSWERS: async (context, payload) => {
    const token = context.rootState.token;
    const { client, questionnaire, answers } = payload;
    const data = { userId: client, answers, questionnaire };

    await questionnaireApi.updateAnswers(token, data);

    await context.dispatch('QUESTIONNAIRE_LOAD_ANSWERS', client);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
